"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dynamicModifiers = require("../../../utils/dynamicModifiers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MenuItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "MenuItemWrapper",
  componentId: "sc-1c8sxsx-0"
})(["display:flex;", " ", ";"], (0, _dynamicModifiers.applyDynamicModifiers)('flex'), (0, _dynamicModifiers.applyDynamicModifiers)('flexDirection', 'flex-direction'));

var _default = MenuItemWrapper;
exports.default = _default;